const blogData = [
  {
    "id": 1294,
    "date": "2021-03-27T16:32:10",
    "date_gmt": "2021-03-27T16:32:10",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1294"
    },
    "modified": "2021-03-30T05:42:29",
    "modified_gmt": "2021-03-30T05:42:29",
    "slug": "ay2021g21d-creature-comforts",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g21d-creature-comforts/",
    "title": {
      "rendered": "AY2021G21D- “Creature Comforts”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EJin Ziqi (FOE), Joseph Koh Boon Sin (SDE), Ma Xudong (FOE), Zhang Han Xiang (FOE)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Wong Kah Wei&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Wong Kah Wei\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Almost half of existing secondary forests will become new developments over the next 10-15 years (CNA, 2020). The loss of habitat forces wildlife into urban areas, leading to human-wildlife interaction. With RVRC being located beside Kent Ridge forest, there is higher likelihood of human-wildlife encounters. In order to educate and build confidence in RVRC residents as first responders in wildlife encounters, we aim to provide accessibility to information required in handling human-wildlife interactions. QR codes were pasted on residents’ doors. If residents encounter animals in their rooms, they could easily scan the code to obtain instructions on safe handling of wildlife. Survey results indicated an increase in respondents’ confidence in animal encounters from 43.1% to 77.8%. 75% of residents were more likely to respond correctly in human-wildlife interaction scenarios. To continue educating future residents, we plan to collaborate with RV Forestore Interest Group and the Office of Housing Services. &quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EAlmost half of existing secondary forests will become new developments over the next 10-15 years (CNA, 2020). The loss of habitat forces wildlife into urban areas, leading to human-wildlife interaction. With RVRC being located beside Kent Ridge forest, there is higher likelihood of human-wildlife encounters. In order to educate and build confidence in RVRC residents as first responders in wildlife encounters, we aim to provide accessibility to information required in handling human-wildlife interactions. QR codes were pasted on residents’ doors. If residents encounter animals in their rooms, they could easily scan the code to obtain instructions on safe handling of wildlife. Survey results indicated an increase in respondents’ confidence in animal encounters from 43.1% to 77.8%. 75% of residents were more likely to respond correctly in human-wildlife interaction scenarios. To continue educating future residents, we plan to collaborate with RV Forestore Interest Group and the Office of Housing Services. \u003C/span\u003E\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EJin Ziqi (FOE), Joseph Koh Boon Sin (SDE), Ma Xudong (FOE), Zhang Han Xiang (FOE) Academic Advisor: Ms. Wong Kah Wei Almost half of existing secondary forests will become new developments over the next 10-15 years (CNA, 2020). The loss of\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 694503],
    "tags": [],
    "class_list": [
      "post-1294",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-natural-environment-and-ecosystem"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1294",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1294"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1294/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1526,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1294/revisions/1526"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1294"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1294"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1294"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1291,
    "date": "2021-03-27T16:29:52",
    "date_gmt": "2021-03-27T16:29:52",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1291"
    },
    "modified": "2021-03-30T05:42:49",
    "modified_gmt": "2021-03-30T05:42:49",
    "slug": "ay2021g21c-masks-on-waste-off",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g21c-masks-on-waste-off/",
    "title": {
      "rendered": "AY2021G21C- “Masks On Waste Off”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EChen Yuxuan (SDE), Gao Xinge (FOE), Jin Yonghe (FOE), Yang Donghan (FOE)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Wong Kah Wei&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Wong Kah Wei\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Improper waste disposal and high waste generation of disposable masks have spiked and adversely exacerbated environmental issues since the onset of COVID-19 both globally and locally. Educating and advocating for reusable mask usage would help reduce disposable mask waste. Education with the engaging activities would foster effective learning and change among RVRC participants. Hence, we utilize a two-pronged approach through conducting an educational workshop and supplying reusable masks to change perceptions and reinforce the wearing of reusable masks instead of disposable masks.\\n\\nWe designed a face-to-face workshop comprising i) a pre- and post-workshop and review survey; ii) distribution of free reusable masks iii) discussion of benefits of reusable mask usage. Our findings showed that 90% of workshop participants continued wearing reusable masks the month after the workshop. Hence, our multi-pronged approach has proven effective in promoting reusable mask usage in RVRC residents.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EImproper waste disposal and high waste generation of disposable masks have spiked and adversely exacerbated environmental issues since the onset of COVID-19 both globally and locally. Educating and advocating for reusable mask usage would help reduce disposable mask waste. Education with the engaging activities would foster effective learning and change among RVRC participants. Hence, we utilize a two-pronged approach through conducting an educational workshop and supplying reusable masks to change perceptions and reinforce the wearing of reusable masks instead of disposable masks.\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003EWe designed a face-to-face workshop comprising i) a pre- and post-workshop and review survey; ii) distribution of free reusable masks iii) discussion of benefits of reusable mask usage. Our findings showed that 90% of workshop participants continued wearing reusable masks the month after the workshop. Hence, our multi-pronged approach has proven effective in promoting reusable mask usage in RVRC residents.\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EChen Yuxuan (SDE), Gao Xinge (FOE), Jin Yonghe (FOE), Yang Donghan (FOE) Academic Advisor: Ms. Wong Kah Wei Improper waste disposal and high waste generation of disposable masks have spiked and adversely exacerbated environmental issues since the onset of COVID-19 both\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 693697],
    "tags": [],
    "class_list": [
      "post-1291",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-responsible-consumption"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1291",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1291"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1291/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1527,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1291/revisions/1527"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1291"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1291"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1291"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1283,
    "date": "2021-03-27T16:26:45",
    "date_gmt": "2021-03-27T16:26:45",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1283"
    },
    "modified": "2021-03-30T05:43:06",
    "modified_gmt": "2021-03-30T05:43:06",
    "slug": "ay2021g21b-thimbles-for-water-conservation",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g21b-thimbles-for-water-conservation/",
    "title": {
      "rendered": "AY2021G21B- “Thimbles for Water Conservation”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EHu Yi (FOE), Liew Tse Chuan Joseph (SDE), Sun Jiawei (FOE), Zhang Bo Ya Grace (SDE)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Wong Kah Wei&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Wong Kah Wei\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Water supply in Singapore is limited and PUB aims to lower water consumption, and an understanding of water use habits would be useful to implement conservation measures. Our objectives were to evaluate the effectiveness of water thimbles and posters in helping residents save water. We carried out our implementation at two floors by: i) installing thimbles and water meters in their pantry taps ii) pasting water conservation posters informing residents that thimbles were installed iii) conducting surveys to understand residents’ tap usage iv) conducting observations and interviews regarding differences in tap usage.\\n\\nThimbles reduced flow rate by ~50%, but total water consumption was hardly reduced despite their installation. Interviews revealed that perceived time spent using the tap was unchanged, though data and observations said otherwise. Thimbles and posters were not proven to be effective in saving water. Residents likely required more direct changes in their water usage habits to save any meaningful amount of water.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EWater supply in Singapore is limited and PUB aims to lower water consumption, and an understanding of water use habits would be useful to implement conservation measures. Our objectives were to evaluate the effectiveness of water thimbles and posters in helping residents save water. We carried out our implementation at two floors by: i) installing thimbles and water meters in their pantry taps ii) pasting water conservation posters informing residents that thimbles were installed iii) conducting surveys to understand residents’ tap usage iv) conducting observations and interviews regarding differences in tap usage.\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003EThimbles reduced flow rate by ~50%, but total water consumption was hardly reduced despite their installation. Interviews revealed that perceived time spent using the tap was unchanged, though data and observations said otherwise. Thimbles and posters were not proven to be effective in saving water. Residents likely required more direct changes in their water usage habits to save any meaningful amount of water.\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EHu Yi (FOE), Liew Tse Chuan Joseph (SDE), Sun Jiawei (FOE), Zhang Bo Ya Grace (SDE) Academic Advisor: Ms. Wong Kah Wei Water supply in Singapore is limited and PUB aims to lower water consumption, and an understanding of water use\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 3558],
    "tags": [],
    "class_list": [
      "post-1283",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-water"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1283",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1283"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1283/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1528,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1283/revisions/1528"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1283"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1283"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1283"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1276,
    "date": "2021-03-27T16:23:07",
    "date_gmt": "2021-03-27T16:23:07",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1276"
    },
    "modified": "2021-03-30T05:43:23",
    "modified_gmt": "2021-03-30T05:43:23",
    "slug": "ay2021g21a-stop-the-drop",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g21a-stop-the-drop/",
    "title": {
      "rendered": "AY2021G21A- “Stop the Drop!”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EWendalyna Lye Liyi (FOE), Ernest Tock Jia En (FOE), Lee Shao Zheng (FOE), Ge Wen Xuan (SDE)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Wong Kah Wei&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Wong Kah Wei\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;There is a need to address Singapore’s high levels of water consumption. While RVRC residents are cognizant of the impacts of water scarcity, they are unaware of how they can contribute to water conservation. Hence, our objective is to encourage collection of cold water which are wasted while waiting for the water to warm up before their shower. Firstly, we found out residents' showering habits through focus group discussions and surveys. We then developed a prototype that provides the option to funnel cold water from the shower into a bucket. Lastly, we investigated their willingness to collect water through a focus group discussion. Our findings showed that a total of 464.96L of water was collected from approximately 207 showers during the 2 weeks of implementation. Hence, the prototype proved effective in encouraging the collection of unused water during showers, raised awareness about water conservation and made water available for reuse.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EThere is a need to address Singapore’s high levels of water consumption. While RVRC residents are cognizant of the impacts of water scarcity, they are unaware of how they can contribute to water conservation. Hence, our objective is to encourage collection of cold water which are wasted while waiting for the water to warm up before their shower. Firstly, we found out residents&#8217; showering habits through focus group discussions and surveys. We then developed a prototype that provides the option to funnel cold water from the shower into a bucket. Lastly, we investigated their willingness to collect water through a focus group discussion. Our findings showed that a total of 464.96L of water was collected from approximately 207 showers during the 2 weeks of implementation. Hence, the prototype proved effective in encouraging the collection of unused water during showers, raised awareness about water conservation and made water available for reuse.\u003C/span\u003E\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EWendalyna Lye Liyi (FOE), Ernest Tock Jia En (FOE), Lee Shao Zheng (FOE), Ge Wen Xuan (SDE) Academic Advisor: Ms. Wong Kah Wei There is a need to address Singapore’s high levels of water consumption. While RVRC residents are cognizant of\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 3558],
    "tags": [],
    "class_list": [
      "post-1276",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-water"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1276",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1276"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1276/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1529,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1276/revisions/1529"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1276"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1276"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1276"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1265,
    "date": "2021-03-27T16:20:43",
    "date_gmt": "2021-03-27T16:20:43",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1265"
    },
    "modified": "2021-03-30T05:43:39",
    "modified_gmt": "2021-03-30T05:43:39",
    "slug": "ay2021g20b-cool-view",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g20b-cool-view/",
    "title": {
      "rendered": "AY2021G20C- “COOL VIEW”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EWang Hanxiao (SDE), Miguel Lim (FOE), Chen Xiayu (FOE), Liu Danfeng (FOE)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Sadaf Ansari&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Sadaf Ansari\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Building construction and operation contributes to 39% of global carbon emissions (IEA, 2019). Active control measures to reduce these emissions tend to have a higher carbon footprint than passive design solutions. Our project examined the impact of 3M solar films in enhancing occupants’ thermal comfort and lighting conditions in RVRC tower block. We selected four pairs of rooms with clear variation in direct sunlight exposure, to conduct a comparative test. Quantitative data for parameters affecting thermal comfort (temperature, radiant temperature, relative humidity, air velocity) and light illuminance level was collected. We also conducted interviews with occupants (n=8) to understand their perceived thermal comfort. Data indicated that the treatment rooms had lower Wet Bulb Globe Temperature than control rooms, with a difference of up to 0.94°C. Based on our interview results and data analysis, we concluded that the installation of 3M solar film was effective in enhancing occupant’s thermal comfort and lighting conditions. &quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EBuilding construction and operation contributes to 39% of global carbon emissions (IEA, 2019). Active control measures to reduce these emissions tend to have a higher carbon footprint than passive design solutions. Our project examined the impact of 3M solar films in enhancing occupants’ thermal comfort and lighting conditions in RVRC tower block. We selected four pairs of rooms with clear variation in direct sunlight exposure, to conduct a comparative test. Quantitative data for parameters affecting thermal comfort (temperature, radiant temperature, relative humidity, air velocity) and light illuminance level was collected. We also conducted interviews with occupants (n=8) to understand their perceived thermal comfort. Data indicated that the treatment rooms had lower Wet Bulb Globe Temperature than control rooms, with a difference of up to 0.94°C. Based on our interview results and data analysis, we concluded that the installation of 3M solar film was effective in enhancing occupant’s thermal comfort and lighting conditions. \u003C/span\u003E\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EWang Hanxiao (SDE), Miguel Lim (FOE), Chen Xiayu (FOE), Liu Danfeng (FOE) Academic Advisor: Ms. Sadaf Ansari Building construction and operation contributes to 39% of global carbon emissions (IEA, 2019). Active control measures to reduce these emissions tend to have\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 694241],
    "tags": [],
    "class_list": [
      "post-1265",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-built-environment-and-green-infrastructure"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1265",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1265"
        }
      ],
      "version-history": [
        {
          "count": 4,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1265/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1530,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1265/revisions/1530"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1265"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1265"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1265"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1260,
    "date": "2021-03-27T16:19:31",
    "date_gmt": "2021-03-27T16:19:31",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1260"
    },
    "modified": "2021-03-30T05:45:51",
    "modified_gmt": "2021-03-30T05:45:51",
    "slug": "ay2021g20b-wewardrobe-a-digital-second-hand-clothes-exchange-platform-for-residential-college-residents-to-reduce-textile-waste",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g20b-wewardrobe-a-digital-second-hand-clothes-exchange-platform-for-residential-college-residents-to-reduce-textile-waste/",
    "title": {
      "rendered": "AY2021G20B- “WeWardrobe: A digital second-hand clothes exchange platform for residential college residents to reduce textile waste”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EShao Yurui (CEG), Lu Qianqian (ISE), Wang Mengyu (ISE), Liu Zhepei (ISE)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Sadaf Ansari&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Sadaf Ansari\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003ETextile waste is a serious issue in Singapore due to the rise of fast fashion and a “throwaway” culture. Cultivating a habit of reuse is important to mitigate this problem. Inspired by similar past GEQ projects, our objective was to design and test a platform for NUS residents that facilitates the exchange of clothes, and enhances the receptivity to wearing second-hand clothes. We chose a digital tool to make the process convenient and flexible. We designed a group chat with a embedded Telegram bot that allowed users to buy and sell their clothes. It also allowed us to track the number of transactions. During the initial launch period of 7 weeks, more than 60 participants actively used the platform. Our survey results indicated a parallel decrease in users frequency of purchasing new clothes. Hence, our digital second-hand clothes exchange platform was effective in reducing textile waste among NUS residents.\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E&nbsp;\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EShao Yurui (CEG), Lu Qianqian (ISE), Wang Mengyu (ISE), Liu Zhepei (ISE) Academic Advisor: Ms. Sadaf Ansari Textile waste is a serious issue in Singapore due to the rise of fast fashion and a “throwaway” culture. Cultivating a habit of\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 693697],
    "tags": [],
    "class_list": [
      "post-1260",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-responsible-consumption"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1260",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1260"
        }
      ],
      "version-history": [
        {
          "count": 3,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1260/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1539,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1260/revisions/1539"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1260"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1260"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1260"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1254,
    "date": "2021-03-27T16:17:41",
    "date_gmt": "2021-03-27T16:17:41",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1254"
    },
    "modified": "2021-03-30T05:45:18",
    "modified_gmt": "2021-03-30T05:45:18",
    "slug": "ay2021g20a-eco-soap-bar-the-building-blocks-of-a-sustainable-habit",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g20a-eco-soap-bar-the-building-blocks-of-a-sustainable-habit/",
    "title": {
      "rendered": "AY2021G20A- “Eco-Soap Bar: The Building Blocks of a Sustainable Habit”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003ESabrina Tan Jie Ying (SDE), Zheng Zongde (FOE), Hu Han Ling(FOE), Wang Runqi (FOE)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Sadaf Ansari&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Sadaf Ansari\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;\\nLiquid soap use has skyrocketed in the APAC market in recent years. Its manufacture and use carries a high environmental footprint, while its plastic packaging directly contributes to increased waste. To mitigate this trend, our project aimed to raise awareness about the negative environmental impacts of liquid soap and promote the use of bar soap as an alternative. We designed an interactive workshop (n=21) with three key objectives: i) enhance knowledge about the detrimental environmental impacts of liquid soap; ii) engage participants in DIY bar soap making; and iii) compare commonly used brands of soaps as liquid and bar versions. We collected data from our workshop participants, and also followed up with them three weeks later to check if there was any change in their choice of soap versions. Our results found 95% of the workshop participants were willing to use and encourage others to use bar soaps, demonstrating a change in their attitude.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003ELiquid soap use has skyrocketed in the APAC market in recent years. Its manufacture and use carries a high environmental footprint, while its plastic packaging directly contributes to increased waste. To mitigate this trend, our project aimed to raise awareness about the negative environmental impacts of liquid soap and promote the use of bar soap as an alternative. We designed an interactive workshop (n=21) with three key objectives: i) enhance knowledge about the detrimental environmental impacts of liquid soap; ii) engage participants in DIY bar soap making; and iii) compare commonly used brands of soaps as liquid and bar versions. We collected data from our workshop participants, and also followed up with them three weeks later to check if there was any change in their choice of soap versions. Our results found 95% of the workshop participants were willing to use and encourage others to use bar soaps, demonstrating a change in their attitude.\u003C/span\u003E\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003ESabrina Tan Jie Ying (SDE), Zheng Zongde (FOE), Hu Han Ling(FOE), Wang Runqi (FOE) Academic Advisor: Ms. Sadaf Ansari Liquid soap use has skyrocketed in the APAC market in recent years. Its manufacture and use carries a high environmental footprint,\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 2044],
    "tags": [],
    "class_list": [
      "post-1254",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-energy"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1254",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1254"
        }
      ],
      "version-history": [
        {
          "count": 3,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1254/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1534,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1254/revisions/1534"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1254"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1254"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1254"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1246,
    "date": "2021-03-27T16:15:25",
    "date_gmt": "2021-03-27T16:15:25",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1246"
    },
    "modified": "2021-03-30T05:45:24",
    "modified_gmt": "2021-03-30T05:45:24",
    "slug": "ay2021g19c-nuse",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g19c-nuse/",
    "title": {
      "rendered": "AY2021G19C- “NUSe”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003ERaveen Prabhu (SOC), Tan Chin Han, Benjamin (SOC), Yang Xiquan (SOC), Thirugnana Sambandam Vasanth (FASS), Koh Jia Xian (SOC)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Sadaf Ansari&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Sadaf Ansari\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;In land scarce Singapore, solid waste disposal is becoming a prevalent issue. As Singapore’s sole landfill is predicted to be filled by 2035, it is crucial to enhance awareness on the importance of reducing solid waste and to provide useful means to do that. Our group created and tested a digital platform to promote the sharing or donation of hostel essentials amongst NUS campus residents. Based on our preliminary findings, the key features of the Telegram channel allowed residents to i) post items to donate or loan, ii) sieve potential wanted essentials, and iii) receive information about reducing individual solid waste. Our channel garnered 51 unique subscribers and 7 successful transactions over a four-week period, from RVRC and CAPT. Based on results of our surveys and interviews with users, we concluded that the channel succeeded in spreading awareness and providing a platform for residents to share goods.\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EIn land scarce Singapore, solid waste disposal is becoming a prevalent issue. As Singapore’s sole landfill is predicted to be filled by 2035, it is crucial to enhance awareness on the importance of reducing solid waste and to provide useful means to do that. Our group created and tested a digital platform to promote the sharing or donation of hostel essentials amongst NUS campus residents. Based on our preliminary findings, the key features of the Telegram channel allowed residents to i) post items to donate or loan, ii) sieve potential wanted essentials, and iii) receive information about reducing individual solid waste. Our channel garnered 51 unique subscribers and 7 successful transactions over a four-week period, from RVRC and CAPT. Based on results of our surveys and interviews with users, we concluded that the channel succeeded in spreading awareness and providing a platform for residents to share goods.\u003Cbr /\u003E\n\u003C/span\u003E\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003ERaveen Prabhu (SOC), Tan Chin Han, Benjamin (SOC), Yang Xiquan (SOC), Thirugnana Sambandam Vasanth (FASS), Koh Jia Xian (SOC) Academic Advisor: Ms. Sadaf Ansari In land scarce Singapore, solid waste disposal is becoming a prevalent issue. As Singapore’s sole landfill\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 693697],
    "tags": [],
    "class_list": [
      "post-1246",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-responsible-consumption"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1246",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1246"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1246/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1535,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1246/revisions/1535"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1246"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1246"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1246"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1243,
    "date": "2021-03-27T16:11:30",
    "date_gmt": "2021-03-27T16:11:30",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1243"
    },
    "modified": "2021-03-30T05:45:37",
    "modified_gmt": "2021-03-30T05:45:37",
    "slug": "ay2021g19b-reusable-diy-cup-holders-as-sustainable-alternatives-to-single-use-plastic-carriers",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g19b-reusable-diy-cup-holders-as-sustainable-alternatives-to-single-use-plastic-carriers/",
    "title": {
      "rendered": "AY2021G19B- “Reusable DIY cup-holders as sustainable alternatives to single-use plastic carriers”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EKo Chi Hong (FASS), Su Yating (SOC), Shantia Koh Jia Wen (SOC), Alex Ye Hein Aung (SOC), Cheryl Li Xiang (BBA)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Sadaf Ansari&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Sadaf Ansari\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;The high volume of waste generated from single-use plastic carriers for takeaway drinks is a prevalent issue in Singapore. To mitigate this waste, our project objective was to design and test a DIY sustainable alternative for takeaway drink carriers for RVRC residents. Our cup holder prototype is made primarily from upcycled clothes waste. We first conducted a performance test for our prototype to measure factors such as strength, durability, drying speed and flexibility in use for different drink sizes. Following this, we conducted a feasibility study with our target audience - high frequency consumers of takeaway drinks. After a three-week trial, results showed that the frequency of cup-holder use by the participants in our trial increased gradually while their use of plastic carriers dropped more than half. Hence, we conclude that our prototype could be a a sustainable alternative to replace single-use plastic carriers for takeaway drinks.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EThe high volume of waste generated from single-use plastic carriers for takeaway drinks is a prevalent issue in Singapore. To mitigate this waste, our project objective was to design and test a DIY sustainable alternative for takeaway drink carriers for RVRC residents. Our cup holder prototype is made primarily from upcycled clothes waste. We first conducted a performance test for our prototype to measure factors such as strength, durability, drying speed and flexibility in use for different drink sizes. Following this, we conducted a feasibility study with our target audience &#8211; high frequency consumers of takeaway drinks. After a three-week trial, results showed that the frequency of cup-holder use by the participants in our trial increased gradually while their use of plastic carriers dropped more than half. Hence, we conclude that our prototype could be a a sustainable alternative to replace single-use plastic carriers for takeaway drinks.\u003C/span\u003E\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EKo Chi Hong (FASS), Su Yating (SOC), Shantia Koh Jia Wen (SOC), Alex Ye Hein Aung (SOC), Cheryl Li Xiang (BBA) Academic Advisor: Ms. Sadaf Ansari The high volume of waste generated from single-use plastic carriers for takeaway drinks is\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 693697],
    "tags": [],
    "class_list": [
      "post-1243",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-responsible-consumption"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1243",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1243"
        }
      ],
      "version-history": [
        {
          "count": 3,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1243/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1536,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1243/revisions/1536"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1243"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1243"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1243"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 1298,
    "date": "2021-03-27T16:10:26",
    "date_gmt": "2021-03-27T16:10:26",
    "guid": {
      "rendered": "https://blog.nus.edu.sg/geq1917symposium/?p=1298"
    },
    "modified": "2021-03-30T05:45:45",
    "modified_gmt": "2021-03-30T05:45:45",
    "slug": "ay2021g19a-fridge-view",
    "status": "publish",
    "type": "post",
    "link": "https://blog.nus.edu.sg/geq1917symposium/2021/03/27/ay2021g19a-fridge-view/",
    "title": {
      "rendered": "AY2021G19A- “Fridge View”"
    },
    "content": {
      "rendered": "\u003Cp\u003E\u003Cspan data-sheets-formula-bar-text-style=\"font-size:13px;color:#000000;font-weight:normal;text-decoration:none;font-family:'Arial';font-style:normal;text-decoration-skip-ink:none;\"\u003EBen Joseph Murphy (SOC), Gerald Neo Ee Ren (SOC), Reno Sam Wei Jie (FASS), Zhou Qi (SOC)\u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E\u003Cstrong\u003EAcademic Advisor\u003C/strong\u003E: \u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ms. Sadaf Ansari&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:1,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0}\"\u003EMs. Sadaf Ansari\u003C/span\u003E\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003EFood wastage is a pressing concern worldwide. Within RVRC, accumulation of unaccounted and expired food in refrigerators produces large amounts of food waste. Our objective was to enhance the current food labeling system in RVRC fridges through digitization, while providing a convenient platform for food sharing, thereby reducing food waste. We implemented a Telegram bot that i) logs items placed into fridges, ii) reminds users near expiry, and iii) stores a database of shared food items that users can access. Within the two blocks where we did the pilot implementation, there was high uptake (52% of residents), and consistent engagement with the bot. Fair levels of sharing through the bot also demonstrated significant potential of a convenient sharing system in reducing food waste. We conclude that the bot has application in RVRC pantries beyond the pilot, as it successfully enhances the food labeling system and reduces food wastage through sharing.\u003C/p\u003E\n\u003Cp style=\"text-align: justify;\"\u003E\u003Cspan data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Food wastage is a pressing concern worldwide. Within RVRC, accumulation of unaccounted and expired food in refrigerators produces large amounts of food waste. Our objective was to enhance the current food labeling system in RVRC fridges through digitization, while providing a convenient platform for food sharing, thereby reducing food waste. We implemented a Telegram bot that i) logs items placed into fridges, ii) reminds users near expiry, and iii) stores a database of shared food items that users can access. Within the two blocks where we did the pilot implementation, there was high uptake (52% of residents), and consistent engagement with the bot. Fair levels of sharing through the bot also demonstrated significant potential of a convenient sharing system in reducing food waste. We conclude that the bot has application in RVRC pantries beyond the pilot, as it successfully enhances the food labeling system and reduces food wastage through sharing.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:5059,&quot;3&quot;:{&quot;1&quot;:0},&quot;4&quot;:{&quot;1&quot;:2,&quot;2&quot;:16776960},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0,&quot;15&quot;:&quot;Arial&quot;}\"\u003E \u003C/span\u003E\u003C/p\u003E\n\u003Cp\u003E&nbsp;\u003C/p\u003E\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "\u003Cp\u003EBen Joseph Murphy (SOC), Gerald Neo Ee Ren (SOC), Reno Sam Wei Jie (FASS), Zhou Qi (SOC) Academic Advisor: Ms. Sadaf Ansari Food wastage is a pressing concern worldwide. Within RVRC, accumulation of unaccounted and expired food in refrigerators produces\u003C/p\u003E\n",
      "protected": false
    },
    "author": 30626,
    "featured_media": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "_et_pb_use_builder": "",
      "_et_pb_old_content": "",
      "_et_gb_content_width": "",
      "footnotes": ""
    },
    "categories": [19221, 697885, 181],
    "tags": [],
    "class_list": [
      "post-1298",
      "post",
      "type-post",
      "status-publish",
      "format-standard",
      "hentry",
      "category-abstracts",
      "category-ay-2020-21",
      "category-food"
    ],
    "_links": {
      "self": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1298",
          "targetHints": {
            "allow": [
              "GET"
            ]
          }
        }
      ],
      "collection": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/users/30626"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/comments?post=1298"
        }
      ],
      "version-history": [
        {
          "count": 5,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1298/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 1538,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/posts/1298/revisions/1538"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/media?parent=1298"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/categories?post=1298"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://blog.nus.edu.sg/geq1917symposium/wp-json/wp/v2/tags?post=1298"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    }
  }
]

export default blogData;